import { LayoutLink } from './LayoutLink';
export class ColaLink extends LayoutLink {
    constructor(edge, source, target) {
        super(edge, source, target);
    }
}
//# sourceMappingURL=ColaLink.js.map